






import {Vue} from "vue-property-decorator"

export default class AuthPage extends Vue {
}
